module.exports = __webpack_public_path__ + "media/images/service-logo-d6293a0f537756252d5fe9a2413b2487.png";